import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { RecommendAgentService } from "@app/core/services/recommend-agent.service";
import { ResultStatus } from "@app/core/models/result-status";
import { RecommendAgent } from "@app/core/models/recommend-agent";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { HelperService } from "@app/core/services/helper.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-recommend-agent",
  templateUrl: "./recommend-agent.component.html",
  styleUrls: ["./recommend-agent.component.scss"],
})
export class RecommendAgentComponent implements OnInit {
  agentRecommendForm: FormGroup;
  sendRecommendAgentModel: RecommendAgent;
  isVisible = false;
  presubmitted = false;
  recommendation: any;
  relationText = "";
  recommendationID: any;
  agentID = 0;
  submitted = false;
  howdoyouknowList = [];
  data: any;
  resultData: any;
  constructor(
    private formBuilder: FormBuilder,
    private recommendAgentService: RecommendAgentService,
    public modalRef: BsModalRef,
    private modalService: BsModalService,
    private authService: AuthenticationService,
    private helperService: HelperService,
    private sanit: DomSanitizer
  ) {
    this.agentID = this.modalService.config.initialState["agentId"];
  }

  ngOnInit() {
    this.setAgentRecommendForm();
    this.bindhowdoyouknowListList();
    if (
      !this.helperService.isUndefinedOrNullOrEmpty(
        this.modalService.config.initialState["id"]
      )
    ) {
      this.recommendationID = this.modalService.config.initialState["id"];
      this.getRecommendationById(this.recommendationID);
    } else {
      this.recommendation = {
        firstName: this.modalService.config.initialState["agentFirstName"],
        lastName: this.modalService.config.initialState["agentLastName"],
        imgUrl: this.modalService.config.initialState["agentImage"],
      };
    }
  }

  getRecommendationById(id) {
    this.recommendAgentService.getRecommendationById(id).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.resultData = result.Data;
        this.agentRecommendForm.controls["howDoYouKnow"].setValue(
          result.Data.HowDoYouKnowId
        );
        this.data = result.Data;
        this.agentRecommendForm.controls["recommendation"].setValue(result.Data.Text);
        this.recommendation = {
          firstName: result.Data.ReceiverName,
          lastName: "",
          imgUrl: result.Data.ReceiverImageUrl,
        };
        this.nextView();
      }
    });
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    } else {
      return this.sanit.bypassSecurityTrustStyle(
        "url(/assets/images/user-icon.png)"
      );
    }
  }

  setAgentRecommendForm() {
    this.agentRecommendForm = this.formBuilder.group({
      howDoYouKnow: new FormControl("", [Validators.required]),
      recommendation: new FormControl("", [Validators.required]),
    });
  }

  nextView() {
    this.presubmitted = true;
    if (
      !this.helperService.isUndefinedOrNullOrEmpty(
        this.agentRecommendForm.controls["howDoYouKnow"].value
      )
    ) {
      this.isVisible = true;
      this.relationText = this.howdoyouknowList.find(
        (x) =>
          x.Value == this.agentRecommendForm.controls["howDoYouKnow"].value
      ).Text;
    }
  }

  sendRecommendation() {
    this.submitted = true;
    if (this.agentRecommendForm.invalid) {
      return false;
    } else {
      this.sendRecommendAgentModel = new RecommendAgent();
      this.sendRecommendAgentModel.Text = this.agentRecommendForm.controls[
        "recommendation"
      ].value;
      this.sendRecommendAgentModel.HowDoYouKnowId = this.agentRecommendForm.controls[
        "howDoYouKnow"
      ].value;
      this.sendRecommendAgentModel.SenderId = +this.authService.getUserInformation()["ID"];
      this.sendRecommendAgentModel.StatusId = 0;
      this.sendRecommendAgentModel.IsDeleted = false;
      this.sendRecommendAgentModel.IsVisible = false;
      this.sendRecommendAgentModel.ReceiverId = this.agentID;

      if (!this.helperService.isUndefinedOrNullOrEmpty(this.resultData) && this.resultData.DateCreated) {
        this.sendRecommendAgentModel.DateCreated = this.resultData.DateCreated;
      }

      if (!this.helperService.isUndefinedOrNullOrEmpty(this.recommendationID)) {
        this.sendRecommendAgentModel.ID = this.recommendationID;
        this.sendRecommendAgentModel.ReceiverId = +this.data.ReceiverId;
        this.recommendAgentService
          .reviseRecommendation(this.sendRecommendAgentModel)
          .subscribe((result) => {
            if (result.Status === ResultStatus.Success) {
              this.modalRef.hide();
            }
          });
      } else {
        this.recommendAgentService
          .sendRecommendation(this.sendRecommendAgentModel)
          .subscribe((result) => {
            if (result.Status === ResultStatus.Success) {
              this.modalRef.hide();
            }
          });
      }
    }
  }

  closeModal() {
    this.modalRef.hide();
  }

  bindhowdoyouknowListList() {
    this.recommendAgentService.getHowDoYouKnowList().subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.howdoyouknowList = result.Data;
      }
    });
  }
}
